import React from 'react';

const About = () => {
    return (
        <section>
            
        </section>
    );
};

export default About;